import { api as transcriptApi } from './auto-generated/transcript'

transcriptApi.enhanceEndpoints({
  endpoints: {},
})

export { transcriptApi }
